import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaShuttleVan, FaBed, FaReceipt } from 'react-icons/fa';
import { Accordion } from 'components/common';
import Hotel from './itinerary/hotel/Hotel';
import Shuttle from './itinerary/shuttle/Shuttle';
import Other from './itinerary/other/Other';

// Section header: gradient icon chip (white glyph) + title + count pill — a bold,
// professional accent so each itinerary type reads at a glance.
const sectionHeader = (Icon, text, count, tone) => (
  <span className="tw-flex tw-items-center tw-gap-3">
    <span
      className="tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-lg tw-flex-shrink-0 tw-text-white"
      style={{ backgroundImage: tone.grad, boxShadow: `0 2px 6px ${tone.shadow}` }}
    >
      <Icon size={16} />
    </span>
    <span className="tw-font-semibold tw-text-slate-800 tw-text-sm">{text}</span>
    {count > 0 && (
      <span
        className="tw-inline-flex tw-items-center tw-justify-center tw-min-w-[20px] tw-h-5 tw-px-1.5 tw-text-xs tw-font-bold tw-rounded-xl"
        style={{ backgroundColor: tone.pillBg, color: tone.pillFg }}
      >
        {count}
      </span>
    )}
  </span>
);

const TONES = {
  shuttle: { grad: 'linear-gradient(135deg, #3b82f6, #2563eb)', shadow: 'rgba(37,99,235,0.35)', pillBg: '#dbeafe', pillFg: '#2563eb' },
  hotel:   { grad: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', shadow: 'rgba(109,40,217,0.35)', pillBg: '#ede9fe', pillFg: '#7c3aed' },
  other:   { grad: 'linear-gradient(135deg, #f59e0b, #d97706)', shadow: 'rgba(217,119,6,0.35)',  pillBg: '#fef3c7', pillFg: '#d97706' },
};

const BookingScheduleItinerary = ({ booking }) => {
  const [activeKeys, setActiveKeys] = useState(['0', '1', '2']);

  const shuttles = booking.shuttles || [];
  const shuttleCount = shuttles.filter((s) => s.other === false).length;
  const otherCount = shuttles.filter((s) => s.other === true).length;
  const hotelCount = (booking.hotels || []).length;

  return (
    <Accordion activeKeys={activeKeys} onChange={setActiveKeys}>
      <Accordion.Item eventKey="0" header={sectionHeader(FaShuttleVan, 'Shuttle', shuttleCount, TONES.shuttle)}>
        <div className="tw-p-4"><Shuttle booking={booking} /></div>
      </Accordion.Item>
      <Accordion.Item eventKey="1" header={sectionHeader(FaBed, 'Accommodation', hotelCount, TONES.hotel)}>
        <div className="tw-p-4"><Hotel booking={booking} /></div>
      </Accordion.Item>
      <Accordion.Item eventKey="2" header={sectionHeader(FaReceipt, 'Others', otherCount, TONES.other)}>
        <div className="tw-p-4"><Other booking={booking} /></div>
      </Accordion.Item>
    </Accordion>
  );
};

BookingScheduleItinerary.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default BookingScheduleItinerary;
